/* eslint-disable no-underscore-dangle */

export const initWalkMe = ({
  IsProdEnv,
}) => {
  const walkme = document.createElement('script');
  let subdirectory;

  if (IsProdEnv) {
    subdirectory = '';
  } else {
    subdirectory = 'test/';
  }

  walkme.type = 'text/javascript';
  walkme.async = true;
  walkme.src = `https://cdn.walkme.com/users/e5cf9506ca6f450b92949a36fcc86750/${subdirectory}walkme_e5cf9506ca6f450b92949a36fcc86750_https.js`;

  const node = document.getElementsByTagName('script')[0];

  node.parentNode.insertBefore(walkme, node);
  window._walkmeConfig = {
    smartLoad: true,
  };
};
